export const THUMBNAIL_COLUMN_COUNT = {
  TINY: 1,
  MOBILE: 1,
  COMPACT: 2,
  LAPTOP: 3,
  DESKTOP: 4,
}
